module.exports = __webpack_public_path__ + "img/elvas-fortedagrac-a-04@3x.9f5e8307.jpg";